var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChangeCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_287_2830)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.86619 12.1995H7.53296V14.5327",
    stroke: "#002342",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6367 12.6555C14.3896 13.3777 13.911 13.9982 13.2752 14.4206C12.6395 14.8431 11.8821 15.0439 11.1205 14.9919C10.359 14.94 9.63585 14.6381 9.06337 14.1332C8.4909 13.6283 8.10106 12.9486 7.95435 12.1995",
    stroke: "#002342",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.666 10.3329H14.9992V7.99963",
    stroke: "#002342",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.89575 9.87679C8.14288 9.15458 8.62146 8.53413 9.25722 8.11168C9.89299 7.68924 10.6504 7.48842 11.412 7.5404C12.1735 7.59237 12.8966 7.89423 13.4691 8.39914C14.0416 8.90404 14.4314 9.58377 14.5781 10.3329",
    stroke: "#002342",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1328 5.66645V1.93329C13.1328 1.68577 13.0345 1.44838 12.8594 1.27335C12.6844 1.09833 12.447 1 12.1995 1H1.93329C1.68577 1 1.44838 1.09833 1.27335 1.27335C1.09833 1.44838 1 1.68577 1 1.93329V9.39962C1 9.64714 1.09833 9.88453 1.27335 10.0596C1.44838 10.2346 1.68577 10.3329 1.93329 10.3329H5.66645",
    stroke: "#002342",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 3.79993H13.1328",
    stroke: "#002342",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.8667 6.13306H6.59986",
    stroke: "#002342",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.8667 7.99963H4.73328",
    stroke: "#002342",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_287_2830"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangeCard);
export default __webpack_public_path__ + "static/media/ChangeCard.c486aa39d2af57461a86697a8c5892ce.svg";
export { ForwardRef as ReactComponent };